import React, { useCallback, FC } from 'react';

import { SpCouponCalendarHeader } from '../../../../molecules/merchant/calendar/sp/SpMerchantCalendarHeader/SpCouponCalendarHeader';
import { useAppDispatch } from '../../../../redux';
import { ActionsCreators as actions } from '../../../../redux/actions/merchants/services';
import { ViewStyle } from '../../../../redux/types/merchants/services';

type Props = {
  baseDate: string;
  isList: boolean;
  hasPrev: boolean;
};

export const SpCouponCalendarHeaderOrganisim: FC<Props> = ({
  baseDate,
  isList,
  hasPrev,
}) => {
  const dispatch = useAppDispatch();

  const onClickCalendar = useCallback(() => {
    dispatch(actions.switchViewStyle(ViewStyle.Calendar));
  }, [dispatch]);

  const onClickList = useCallback(() => {
    dispatch(actions.switchViewStyle(ViewStyle.List));
  }, [dispatch]);

  const moveNext = useCallback(() => {
    dispatch(actions.moveNext());
  }, [dispatch]);

  const movePrev = useCallback(() => {
    dispatch(actions.movePrev());
  }, [dispatch]);

  return (
    <SpCouponCalendarHeader
      baseDate={baseDate}
      isList={isList}
      hasPrev={hasPrev}
      onClickCalendar={onClickCalendar}
      onClickList={onClickList}
      onClickNext={moveNext}
      onClickPrev={movePrev}
    />
  );
};
